import { Box, Button, Link, useMediaQuery, useTheme } from "@mui/material";

export const TechMeetButton = ({
  color = "primary",
  textTransform = "uppercase",
}) => {
  return (
    <Button
      LinkComponent={Link}
      href="https://tech-meet.betca.org/"
      target="_blank"
      variant="contained"
      size="small"
      color={color}
      sx={{
        textTransform: textTransform,
        mb: 2,
        borderRadius: "12px",
        color: "#ffff",
      }}
    >
      Register for Tech Meet 2026
    </Button>
  );
};

export const Image = ({ image, alt, width = 20, className, sx }) => {
  return (
    <Box sx={{ ...sx, p: 0, m: 0 }}>
      <img
        className={className ? className : undefined}
        src={image}
        alt={alt}
        width={width}
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
      />
    </Box>
  );
};

export const useMediaQueries = () => {
  const theme = useTheme();
  const downSM = useMediaQuery(theme.breakpoints.down("sm"));
  const downMD = useMediaQuery(theme.breakpoints.down("md"));
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  return {
    isDownSM: downSM,
    isDownMD: downMD,
    isDownLG: downLG,
  };
};
